<template>
  <v-text-field
    :id="id"
    v-model="text"
    :rules="textRules.concat(printabilityRules)"
    :type="type"
    :label="
      showLabel
        ? label + (required || hideOptionalText ? '' : ' (optional)')
        : ''
    "
    :placeholder="placeholder"
    :validate-on-blur="true"
    :disabled="disabled"
    :clearable="clearable"
    :dense="dense"
    :maxLength="maxLength"
    :errorMessages="errors"
    :color="$colors.penChecksTeal"
    :hint="hint"
    :persistent-hint="persistentHint"
    :append-icon="appendIcon"
    v-on="$listeners"
    @keyup.enter="$emit('enter', $event)"
    @change="$emit('change', text)"
    @click:clear="$emit('clear')"
    @blur="$emit('blur')"
    @focus="errors = null"
    ref="textfield"
    :data-id="dataId"
  ></v-text-field>
</template>
<script>
import { isPOBox } from "@/shared/utils/address-utils";
import {
  PRINTABLE_CHARS_REGEX,
  PRINTABLE_CHARS_ERROR_MESSAGE,
} from "@/shared/lib/printable-chars";
import { nameCharsRule } from "@/shared/lib/name-chars";

export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
    },
    appendIcon: {
      type: String,
    },
    id: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
    },
    errorMessages: {
      type: Array,
    },
    dense: {
      type: Boolean,
    },
    noPostOfficeBoxes: {
      type: Boolean,
    },
    printableCharsValidation: {
      type: Boolean,
    },
    nameCharsValidation: {
      type: Boolean,
    },
    hint: {
      type: String,
    },
    persistentHint: {
      type: Boolean,
    },
    hideOptionalText: {
      type: Boolean,
    },
    maxLength: {
      type: Number,
    },
    minLength: {
      type: Number,
    },
    dataId: {
      type: String,
      required: true,
      // data-id must be a 32 character UUID
      validator(value) {
        return value.length == 32;
      },
    },
  },

  data: function () {
    return {
      text: this.value,
      textRules: [
        (v) =>
          !this.required ||
          !!v ||
          "Please enter " +
            (this.label.toUpperCase() == this.label
              ? this.label
              : this.label.toLowerCase()),
        () => {
          if (!this.value || this.value == "" || !this.noPostOfficeBoxes)
            return true;
          if (isPOBox(this.value))
            return "Post office box is not allowed. Please enter a physical address.";
          return true;
        },
      ],
      printabilityRules: [
        (v) => !this.nameCharsValidation || nameCharsRule(v),
        (v) => {
          if (this.printableCharsValidation) {
            if (PRINTABLE_CHARS_REGEX.test(v)) {
              return PRINTABLE_CHARS_ERROR_MESSAGE;
            }
            return true;
          }
          return true;
        },
        () => {
          if (!this.value || this.value == "" || !this.minLength) return true;
          if (this.value.length < this.minLength)
            return (
              (this.label.toUpperCase() == this.label
                ? this.label
                : this.label.charAt(0).toUpperCase() +
                  this.label.slice(1).toLowerCase()) +
              ` needs a minimun of ${this.minLength} letters.`
            );
          return true;
        },
      ],
      errors: null,
    };
  },
  watch: {
    text(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      if (this.text != newValue) {
        this.text = newValue;
      }
    },
    errorMessages(errors) {
      this.errors = errors;
    },
  },

  mounted() {
    this.$emit("mounted");
  },
};
</script>

<style lang="scss"></style>
